import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '@onefootprint/icons';
import { IcoLayer0124, IcoSmartphone224, IcoSparkles24, IcoSquareFrame24 } from '@onefootprint/icons';
import { BottomSheet } from '@onefootprint/ui';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import type { AutoCaptureKind } from '../../../camera/types';
import InstructionItems from './components/instruction-item';
type InstructionProps = {
  onClose: () => void;
  isOpen: boolean;
  autoCaptureKind: AutoCaptureKind;
};
const Instructions = t0 => {
  const $ = _c(13);
  const {
    onClose,
    isOpen,
    autoCaptureKind
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.photo-capture.instructions"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const captureKind = autoCaptureKind === "face" ? "face" : "document";
  let instructionItems;
  if ($[1] !== captureKind || $[2] !== t) {
    const positionTitle = captureKind === "face" ? t(_temp) : t(_temp2);
    const positionDescription = captureKind === "face" ? t(_temp3) : t(_temp4);
    const autocaptureTitle = captureKind === "face" ? t(_temp5) : t(_temp6);
    const autocaptureDescription = captureKind === "face" ? t(_temp7) : t(_temp8);
    instructionItems = [{
      title: positionTitle,
      description: positionDescription,
      Icon: IcoSquareFrame24
    }, {
      title: t(_temp9),
      description: t(_temp10),
      Icon: IcoSmartphone224
    }, {
      title: autocaptureTitle,
      description: autocaptureDescription,
      Icon: IcoSparkles24
    }];
    if (captureKind === "document") {
      instructionItems.unshift({
        title: t(_temp11),
        description: t(_temp12),
        Icon: IcoLayer0124
      });
    }
    $[1] = captureKind;
    $[2] = t;
    $[3] = instructionItems;
  } else {
    instructionItems = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t(_temp13);
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== instructionItems) {
    t3 = <InstructionItems items={instructionItems} />;
    $[6] = instructionItems;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isOpen || $[9] !== onClose || $[10] !== t2 || $[11] !== t3) {
    t4 = <BottomSheet onClose={onClose} open={isOpen} title={t2}>{t3}</BottomSheet>;
    $[8] = isOpen;
    $[9] = onClose;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default Instructions;
function _temp($) {
  return $["position-face"].title;
}
function _temp2($_0) {
  return $_0["position-document"].title;
}
function _temp3($_1) {
  return $_1["position-face"].description;
}
function _temp4($_2) {
  return $_2["position-document"].description;
}
function _temp5($_3) {
  return $_3["autocapture-face"].title;
}
function _temp6($_4) {
  return $_4["autocapture-document"].title;
}
function _temp7($_5) {
  return $_5["autocapture-face"].description;
}
function _temp8($_6) {
  return $_6["autocapture-document"].description;
}
function _temp9($_7) {
  return $_7.steady.title;
}
function _temp10($_8) {
  return $_8.steady.description;
}
function _temp11($_9) {
  return $_9.background.title;
}
function _temp12($_10) {
  return $_10.background.description;
}
function _temp13($_11) {
  return $_11.title;
}